module.exports = __webpack_public_path__ + "static/media/(V)_MG_4627_-_Pro-Natura_-_Moda_Feminina_-_Acessorios.b1fc502e.jpg";